import { useMatches } from "react-router"

export const LAYOUT_WIDTHS = {
  fullscreen: "fullscreen",
  narrow: "narrow",
  sermonEpisodeLayout: "sermon-episode-layout",
  wide: "wide",
} as const

export type LayoutWidth = (typeof LAYOUT_WIDTHS)[keyof typeof LAYOUT_WIDTHS]

// a type for use on our route `handle`s like
// export const handle = { layoutWidth: LAYOUT_WIDTHS.wide } satisfies LayoutHandle
export type LayoutHandle = {
  layoutWidth?: LayoutWidth
}

// The layoutWidth from the deepest matched route that declares one.
export function useRouteLayoutWidth(): LayoutWidth | undefined {
  const matches = useMatches()

  for (let i = matches.length - 1; i >= 0; i--) {
    const layoutWidth = (matches[i].handle as LayoutHandle | undefined)
      ?.layoutWidth
    if (layoutWidth != null) return layoutWidth
  }

  return undefined
}
